var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { label3 } from "@irati/ui/src/Labels/css/labels";
import padding from "@irati/ui/src/global/padding";
import { FormattedMessage } from "@irati/utils/lang";
import Empty from "./EmptyRewards";
import MyRewardsItem from "./MyRewardsItem";
var ColHeader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  padding-bottom: ", ";\n"], ["\n  ", "\n  padding-bottom: ", ";\n"])), label3, padding.tiny);
var MyRewardsList = /** @class */ (function (_super) {
    __extends(MyRewardsList, _super);
    function MyRewardsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyRewardsList.prototype.render = function () {
        var _a = this.props, redemptions = _a.redemptions, openPopUp = _a.openPopUp;
        if (redemptions.length === 0) {
            return (React.createElement(Row, null,
                React.createElement(Empty, null)));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Row, null,
                React.createElement(Col, { xsHidden: true, sm: 7 }),
                React.createElement(Col, { xsHidden: true, sm: 3 },
                    React.createElement(ColHeader, null,
                        React.createElement(FormattedMessage, { id: "recognition.account.rewards.receivedHeader" }))),
                React.createElement(Col, { xsHidden: true, sm: 2 },
                    React.createElement(ColHeader, null,
                        React.createElement(FormattedMessage, { id: "recognition.account.rewards.actionHeader" })))),
            redemptions.map(function (redemption) {
                return React.createElement(MyRewardsItem, { openPopUp: openPopUp, key: redemption.id, redemption: redemption });
            })));
    };
    return MyRewardsList;
}(PureComponent));
export default MyRewardsList;
var templateObject_1;
